import { getNotifications, removeNotification } from '@vista-digital/occ-domain'
import { useEffect } from 'react'
import { Services } from '../services'

const useNotificationObserver = () => {
    useEffect(() => {
        Services.NavigationService.pageObs.observe_(({ newValue, oldValue }) => {
            /*
             * If a notification appears and you navigate to a new page before it dismounts, it will reappear again.
             * To fix this, we remove present notifications if the page changes. This will not run on page load.
             * */
            if (newValue !== oldValue) {
                const notifications = getNotifications()
                notifications.forEach(notification => {
                    removeNotification(notification.id)
                })
            }
        })
    }, [])
}

export default useNotificationObserver
